import CardTransferCard from "./CardTransferCard";
import ChatAddNoteComponent from "./ChatAddNoteComponent";
import HttpRequestComponent from "./HttpRequestComponent";
import CardSendMessage from "./CardSendMessage";
import ChatAddTag from "./ChatAddTag";
import ChatRemoveTag from "./ChatRemoveTag";
import CardNewLead from "./CardNewLead";
import CardReactionMoverCardFunil from "./CardReactionMoverCardFunil";
import CardChangeValue from "./CardChangeValue";
import CardSendMake from "./CardSendMake";
import CardFinishChat from "./CardFinishChat";
import CardTransferChat from "./CardTransferChat";
import CardAssignChat from "./CardAssignChat";
import CardWait from "./CardWait";

export default function BlockRenderer({ block, changeBlock, availableVariables, actionPhase, actionState, canais, user }) {
  switch (block.value) {
    case "to.funnel.cardTransferUser":
      return <CardTransferCard user={user} block={block} changeBlock={changeBlock} />;
    case "to.chat.addNote":
      return <ChatAddNoteComponent block={block} changeBlock={changeBlock} />;
    case "to.httpRequest":
      return <HttpRequestComponent block={block} availableVariables={availableVariables} changeBlock={changeBlock} />;
    case "to.chat.sendMessage":
      return <CardSendMessage block={block} changeBlock={changeBlock} actionState={actionState} actionPhase={actionPhase} canais={canais} />;
    case "to.chat.addTag":
      return <ChatAddTag block={block} changeBlock={changeBlock} />;
    case "to.chat.removeTag":
      return <ChatRemoveTag block={block} changeBlock={changeBlock} />;
    case "to.funnel.cardCreate":
      return <CardNewLead block={block} changeBlock={changeBlock} />;
    case "to.moveCardStage":
      return <CardReactionMoverCardFunil block={block} changeBlock={changeBlock} />;
    case "to.funnel.action":
      return <CardChangeValue block={block} changeBlock={changeBlock} />;
    case "to.sendMake":
      return <CardSendMake block={block} changeBlock={changeBlock} />;
    case "to.chat.finish":
      return <CardFinishChat block={block} changeBlock={changeBlock} />;
    case "to.chat.transfer":
      return <CardTransferChat user={user} block={block} changeBlock={changeBlock} />;
    case "to.chat.assign":
      return <CardAssignChat user={user} block={block} changeBlock={changeBlock} />;
    case "to.wait":
      return <CardWait block={block} changeBlock={changeBlock} />;
    default:
      return null;
  }
}
